import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import bannerImg from "@/assets/service/banner-service.png";
import useLocale from "@/hooks/useLocale";

export default function ServicePageBanner({ title, path }) {
  const locale = useLocale();

  return (
    <div>
      <div className="md:px-2 2xl:px-11 md:pt-7 mx-auto w-full relative">
        <img
          src={bannerImg ?? ""}
          alt="background"
          className="w-full h-[450px] md:h-auto object-cover max-h-[780px]"
        />
        <div className="absolute bottom-[5vw] sm:max-w-[1110px] px-5 lg:pl-[70px] z-50">
          <p className="text-sm sm:text-base lg:text-lg/[27px] text-blue font-semibold pb-3">
            {title}
          </p>
          <div className="flex">
            <h2 className="text-[40px]/[50px] lg:text-6xl xl:text-[100px] text-white">
              <CustomSourceFlowText
                title="Our most comprehensive search solution"
                path={`dynamic1.${path}.header1`}
                locale={locale}
              />
              <span className="text-blue">.</span>
            </h2>
          </div>
          <p className="text-lg/[20px] sm:text-xl/[30px] lg:text-[30px]/[40px] text-white mt-5 sm:mt-10 max-w-[810px]">
            <CustomSourceFlowText
              title=" We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve."
              path={`dynamic1.${path}.text1`}
              locale={locale}
            />
          </p>
        </div>
      </div>
    </div>
  );
}
